import { render, staticRenderFns } from "./Feedback-TesteEmpregabilidade.vue?vue&type=template&id=1d63a11e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports